export const INIT_DASHBOARD = 'initdashboard'
export const GET_USER_DASHBOARD_END='getusedashboard.end'
export const GET_DASHBOARD_DATA_END='getdashboarddata.end'
export const UPDATE_DASHBOARD_ANALYTICS_PARMS='upatedashboardanalyticsparams'
export const RESET_PARAMS='resetparams'
export const GET_USER_BRANCH_END='getuserbranch.end'
export const GET_AGENT_LIST_END='GET_AGENT_LIST_END.END'
export const GET_SALE_CHANNEL_LIST_END='GET_SALE_CHANNEL_LIST_END.END'
export const SAVE_DROPDOWN_VALUES_END='SAVE_DROPDOWN_VALUES_END.END'
export const SET_SELECTED_AGENTS='SET_SELECTED_AGENTS.END'
